import { colors, spacing } from '@akin-home/theme';
import { IconProp } from '@fortawesome/fontawesome-svg-core';
import { FontAwesomeIcon } from '@fortawesome/react-native-fontawesome';
import React from 'react';
import {
  ColorValue,
  Pressable,
  StyleSheet,
  Text,
  TextStyle,
  View,
  ViewStyle,
} from 'react-native';

type RobotActionsButtonProps = {
  style?: ViewStyle;
  text?: string;
  textColor?: ColorValue;
  textStyle?: TextStyle;
  icon?: IconProp;
  iconSize?: number;
  iconColor?: ColorValue;
  disabled?: boolean;
  onPress?: () => void;
};

export const RobotActionsButton = (props: RobotActionsButtonProps) => {
  const {
    disabled = false,
    text,
    textColor,
    icon,
    iconColor,
    iconSize = 60,
  } = props;

  const handlePress = () => {
    props.onPress?.();
  };

  return (
    <Pressable
      style={[
        styles.container,
        disabled ? styles.disabledBackground : styles.background,
        props.style,
      ]}
      disabled={disabled}
      onPress={handlePress}
      android_ripple={{ color: 'gray', borderless: false }}
    >
      {icon ? (
        <View style={styles.iconContainer}>
          <FontAwesomeIcon
            icon={icon}
            size={iconSize}
            color={disabled ? colors.grey.dim : (iconColor as string)}
          />
        </View>
      ) : null}
      {text ? (
        <Text
          style={[
            styles.text,
            {
              fontSize: iconSize / 4.5,
              color: disabled ? colors.grey.dim : textColor,
            },
            props.textStyle,
          ]}
          // adjustsFontSizeToFit
        >
          {text}
        </Text>
      ) : null}
    </Pressable>
  );
};

const styles = StyleSheet.create({
  container: {
    justifyContent: 'space-evenly',
    alignItems: 'center',
    flexDirection: 'column',
    padding: spacing[2],
  },
  background: {
    backgroundColor: colors.blue.background,
    borderRadius: 10,
    elevation: 2,
  },
  disabledBackground: {
    backgroundColor: colors.grey[300],
    borderRadius: 10,
    elevation: 0,
  },
  iconContainer: {
    flex: 1,
    justifyContent: 'center',
  },
  text: {
    fontWeight: 'bold',
    textAlign: 'center',
    textAlignVertical: 'center',
    height: '30%',
  },
});
